<template>
	<section class="content">
		<header>
			<div class="container">
				<router-link to="/">
					<img src="@/assets/images/ensineme.png" alt="Logo projeto Joana" class="logo" />
				</router-link>
				<search-area />
				<nav-bar />
			</div>
		</header>

		<main>
			<div class="pattern"></div>

			<load-content v-if="loadContent" />
			<div class="main-content container">
				<router-view />
			</div>
		</main>

		<footer-page />
	</section>
</template>

<script>
import NavBar from '@/components/shared/NavBar'
import SearchArea from '@/components/shared/SearchArea'
import FooterPage from '@/components/shared/Footer'
import EventBus from './../event-bus'
import LoadContent from '@/components/shared/LoadContent'

export default {
	name: 'MainLayout',
	components: { NavBar, SearchArea, FooterPage, LoadContent },
	data () {
		return {
			loadContent: true
		}
	},
	created () {
		EventBus.$on('closeLoader', (loadContent) => {
			this.loadContent = loadContent
		})
	}
}
</script>

<style lang="scss" scoped>
	.content {

		header {
			width: 100%;
			height: 160px;
			background: url(../../assets/images/bgblue.png) no-repeat;
			background-size: cover;
			position: fixed;
			z-index: 2;
			top: 0;
			left: 0;

			-webkit-box-shadow: 0 8px 6px -6px $dark-blue;
			-moz-box-shadow: 0 8px 6px -6px $dark-blue;
			box-shadow: 0 8px 6px -6px $dark-blue;

			@media all and (max-width: 1440px) {
				padding: 0 20px;
			}

			.container {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: inherit;
				.logo {
					width: 150px;
				}
			}

		}

		main {
			position: relative;
			margin-top: 164px;
			padding-bottom: 160px;
			width: 100%;

			.pattern {
				background: url(../../assets/images/bg.svg);
				background-size: 40px;
				height: 260px;
				position: absolute;
				width: 100%;
				z-index: -1;
			}

			.main-content {
				width: 100%;
				padding-top: 30px;
				position: relative;

				@media all and (max-width: 1440px) {
					padding: 100px 20px 0 20px;
				}

				@media all and (max-width: 700px) {
					display: grid;
				}
			}
		}
	}
	@media all and (max-width: 1024px) {
		.container {
			a {
				order: 1;
			}
			.search-area {
				order: 3;
				margin: 0 auto;
			}
			nav {
				order: 2;
			}
		}
	}
</style>
